import { render } from "./GRNBoxInward.vue?vue&type=template&id=d8b51a96&scoped=true"
import script from "./GRNBoxInward.vue?vue&type=script&lang=js"
export * from "./GRNBoxInward.vue?vue&type=script&lang=js"

import "./GRNBoxInward.vue?vue&type=style&index=0&id=d8b51a96&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8b51a96"]])

export default __exports__